import React, { Component } from "react";
import SearchForm from "./SearchForm";
import RefillStatusTab from "./RefillStatusTab";

class RefillManagementLandingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hospital:
        window.location.port !== process.env.REACT_APP_HOSPITAL_PORT &&
        window.location.hostname !== process.env.REACT_APP_HOSPITAL_URL,
    };
  }
  render() {
    return (
      <div style={{ textAlign: "center" }}>
        <div style={{ height: 100, margin: "auto", paddingTop: "30px" }}>
          <h2> Refill Management Sheet </h2>
          <hr width="300" />
        </div>

        <br />
        <br />

        {this.state.hospital && <SearchForm />}

        <hr />

        <br />
        <br />

        <RefillStatusTab />
      </div>
    );
  }
}

export default RefillManagementLandingPage;



// WEBPACK FOOTER //
// ./src/component/RefillManagementSystem/RefillManagementLandingPage.js